import { InjectionToken } from '@angular/core';
import { CanvasRequestContext } from '@panaya/ai-chat/shared';

/**
 * What the frame needs from its content without knowing what it is. The draft family provides one; a host that
 * renders other content may provide its own.
 */
export interface CanvasContentContributor {
    /** Fields the content adds to the `canvas` request-context object (`draft_id`, `version`, `selected_ids`). */
    requestContext(): Partial<CanvasRequestContext>;
    primaryActionEnabled(): boolean;
    /** A locale key the frame shows as a tooltip while the primary action is disabled, such as why; leave it out for none. */
    primaryActionHint?(): string | null;
    /** The content is still being produced; the footer shows the busy pill. */
    busy(): boolean;
    /** Some content exists. Decides whether an error replaces the content or shows under it. */
    hasContent(): boolean;
    /** The content's own header text, such as the draft's title; `null` keeps the registration's title key. */
    title(): string | null;
    /**
     * An error the content itself reports while it still has something to show, such as a draft whose revise call
     * failed: shown in the footer under the content, as a `canvas_status error` message is. `null` when there is none.
     */
    errorMessage?(): string | null;
}

export const CANVAS_CONTENT_CONTRIBUTOR = new InjectionToken<CanvasContentContributor>('__CANVAS_CONTENT_CONTRIBUTOR__');

export const NO_CONTENT_CONTRIBUTOR: CanvasContentContributor = {
    requestContext: () => ({}),
    primaryActionEnabled: () => false,
    busy: () => false,
    hasContent: () => false,
    title: () => null
};
